export const APPLE_MAPS_URL = 'https://maps.apple.com/maps'
export const GOOGLE_MAPS_URL = 'https://maps.google.com/maps'
